import React from 'react'
import { List, Flex, Checkbox, Text } from '@leverege/ui-elements'

export default function GroupPermissionList( props ) {
  
  const { groups = [], selected, onSelect, onEvent, headerOptions : HdrOpts, itemRenderer, itemProps } = props
  const ip = { ...itemProps, currentSelections : selected }
  return (
    <List variant="permissionsSelector" onEvent={onSelect}>
      {
        groups.map( ( grp ) => {
          let type = 'PROJECT'
          if ( grp.module.projectId === 'imagine' ) {
            type = 'IMAGINE'
          } else if ( grp.module.scope === 'custom' ) {
            type = 'CUSTOM'
          }

          return (
            [
              <List.Header key={`${grp.module.projectId}-${grp.module.name}`}>     
                <Flex variant="rowS" align="baseline" >
                  {grp.module.displayName || grp.module.name}
                  <Text variant="info">{type}</Text>
                  {HdrOpts && <HdrOpts item={grp} onEvent={onEvent} />}
                </Flex>
              </List.Header>,
              <List.Dynamic 
                key={`${grp.module.projectId}-${grp.module.name}-perms`}
                items={grp.permissions} 
                component={itemRenderer || PermissionItem} 
                itemProps={ip}/>
            ]
          )
        } ) 
      }
    </List>
  )
}

function PermissionItem( props ) {
  const { item, onEvent, editable, currentSelections = {}, ...rest } = props
  const { id, displayName, name, module } = item.permission
  return (
    <List.Item item={item} {...rest} >
      <Flex variant="rowM">
        <Checkbox value={currentSelections[id] != null} disabled={editable === false} eventData={item.permission} onChange={onEvent}/>
        <Text variant="listItemSubtitle">{displayName || name}</Text>
      </Flex>
    </List.Item>
  )
}
